
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"25","viewBox":"0 0 25 25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.5 24.733c6.627 0 12-5.536 12-12.366S19.127 0 12.5 0 .5 5.537.5 12.367c0 6.83 5.373 12.366 12 12.366z","fill":"#EBB113"}}),_c('path',{attrs:{"d":"M12.309 14.33h-.381c-.571 0-1.143-.588-1.143-1.177v-5.89c0-.588.572-1.177 1.143-1.177h.381c.571 0 1.143.589 1.143 1.178v5.889c-.19.588-.572 1.177-1.143 1.177zm0 4.712h-.381c-.571 0-1.143-.589-1.143-1.178v-.589c0-.588.572-1.177 1.143-1.177h.381c.571 0 1.143.588 1.143 1.177v.59c-.19.588-.572 1.177-1.143 1.177z","fill":"#010814"}})])
          )
        }
      }
    